theme.headerMainMenuModule = (function () {
  function mainMenu(e) {
    let headerWrapper = e.querySelector(".header_bottom");
    let menuLiSelector = document.querySelectorAll(".header__menu_li");
    const menuDisplayType = e.dataset.menuDisplay; // 'click' or 'hover'
    const menuDisplayDelay = parseFloat(e.dataset.menuDisplayDelay) * 1000 || 0; // Convert to milliseconds

    // Geschwister-Eintraege, die denselben <ul>-Elternknoten teilen (z.B. die
    // Challenge-Unterpunkte "Harter Brocken MTB/TRAIL/GRAVEL/ROAD"), bilden
    // zusammen EINE durchgehende Hover-Zone. Bisher schloss jedes Item sein
    // eigenes <details> sofort bei mouseleave -- dadurch klappte das Panel
    // beim Ueberqueren der Luecke zwischen zwei Items kurz zu, bevor das
    // naechste (mit Verzoegerung) wieder aufklappte. Jetzt wird pro Gruppe
    // verwaltet: Wechsel zwischen bereits offenen Geschwistern schaltet
    // sofort um (kein Zuklappen dazwischen), und nur das Verlassen der
    // GESAMTEN Gruppe (nicht eines Einzelitems) startet das Schliessen.
    if (menuDisplayType === "hover") {
      const groups = new Map();
      menuLiSelector.forEach((item) => {
        if (!item.classList.contains("menu__item_has_children")) return;
        const parentList = item.closest("ul") || item.parentElement;
        if (!groups.has(parentList)) {
          groups.set(parentList, { items: [], openTimeout: null, closeTimeout: null });
        }
        groups.get(parentList).items.push(item);
      });

      function getPanel(item) {
        return item.querySelector(".header__mega_menu, .header__sub_menu");
      }

      // Beim Wechsel zwischen bereits offenen Geschwistern (MTB -> Trail -> ...)
      // bekommt das Panel kurzzeitig eine schnelle, reine Opacity-Transition statt
      // der langsameren Standard-Transition (die zusaetzlich margin-top mitanimiert
      // und dadurch wie ein leichtes Verrutschen/Springen wirkt). Beim eigentlichen
      // Oeffnen/Schliessen der gesamten Gruppe bleibt die normale Slide+Fade-Animation
      // unveraendert erhalten.
      function openItem(item, fastSwitch) {
        const listDetails = item.querySelector("details");
        const panel = getPanel(item);
        if (panel) panel.classList.toggle("mega-switch-fast", !!fastSwitch);
        listDetails.setAttribute("open", "");
        item.querySelector("summary").setAttribute("aria-expanded", true);
        headerWrapper.classList.add("mega--menu-open");
      }

      function closeItem(item, fastSwitch) {
        const listDetails = item.querySelector("details");
        const panel = getPanel(item);
        if (panel) panel.classList.toggle("mega-switch-fast", !!fastSwitch);
        listDetails.removeAttribute("open");
        item.querySelector("summary").setAttribute("aria-expanded", false);
      }

      groups.forEach((group, parentList) => {
        group.items.forEach((item) => {
          item.addEventListener("mouseenter", () => {
            if (group.closeTimeout) {
              clearTimeout(group.closeTimeout);
              group.closeTimeout = null;
            }
            if (group.openTimeout) {
              clearTimeout(group.openTimeout);
            }

            const isAlreadyOpen = item.querySelector("details").hasAttribute("open");
            const anotherSiblingOpen = group.items.some(
              (sibling) => sibling !== item && sibling.querySelector("details").hasAttribute("open")
            );
            // Beim allerersten Oeffnen greift die konfigurierte Verzoegerung;
            // beim Wechsel zwischen bereits sichtbaren Geschwistern (die Luecke
            // dazwischen) wird sofort umgeschaltet, ohne erneut zu verzoegern.
            const delay = anotherSiblingOpen || isAlreadyOpen ? 0 : menuDisplayDelay;

            group.openTimeout = setTimeout(() => {
              group.items.forEach((sibling) => {
                if (sibling !== item) closeItem(sibling, anotherSiblingOpen);
              });
              openItem(item, anotherSiblingOpen);
            }, delay);
          });

          item.querySelector("summary").addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            const menuItemUrl = item.querySelector("summary").dataset.href;
            if (menuItemUrl) {
              location.href = menuItemUrl;
            }
          });
        });

        // Erst beim Verlassen der GESAMTEN Geschwister-Gruppe (nicht eines
        // einzelnen Items) wird das Schliessen eingeleitet, mit kurzer
        // Gnadenfrist gegen Rand-Flackern beim Verlassen ueber einen Randpixel.
        parentList.addEventListener("mouseleave", () => {
          if (group.openTimeout) {
            clearTimeout(group.openTimeout);
            group.openTimeout = null;
          }
          group.closeTimeout = setTimeout(() => {
            group.items.forEach((sibling) => closeItem(sibling));
            headerWrapper.classList.remove("mega--menu-open");
          }, 120);
        });
      });
    }

    menuLiSelector.forEach((item) => {
      if (item.classList.contains("menu__item_has_children")) {
        let menuItemUrl = "";
        let menuItemLocation = "";

        if (menuDisplayType === "click") {
          // CLICK MODE
          // Remove hover effects in click mode
          item.addEventListener("mouseover", (event) => {
            event.preventDefault();
          });

          item.addEventListener("mouseleave", (event) => {
            event.preventDefault();
          });

          // Toggle menu on click
          item.querySelector("summary").addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            let listDetails = item.querySelector("details");
            let isOpen = listDetails.hasAttribute("open");
            
            if (isOpen) {
              // Menu is open - navigate to URL
              menuItemUrl = item.querySelector("summary").dataset.href;
              if (menuItemUrl) {
                location.href = menuItemUrl;
              }
            } else {
              // Menu is closed - open it
              listDetails.setAttribute("open", "");
              item.querySelector("summary").setAttribute("aria-expanded", true);
              headerWrapper.classList.add("mega--menu-open");
            }
          });

          // Close menu when clicking outside
          document.addEventListener("click", (event) => {
            if (!item.contains(event.target)) {
              let listDetails = item.querySelector("details");
              listDetails.removeAttribute("open");
              item.querySelector("summary").setAttribute("aria-expanded", false);
              headerWrapper.classList.remove("mega--menu-open");
            }
          });
        }
      }
    });
  }
  return mainMenu;
})();
